import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from './firebase';

/**
 * Log a GA4 event (free; no Firestore cost). Safe no-op when analytics isn't
 * available (e.g. unsupported browser, ad-blockers, before init resolves).
 * Keep params small and non-PII.
 */
export function track(event, params = {}) {
    try {
        const analytics = getAnalyticsInstance();
        if (analytics) logEvent(analytics, event, params);
    } catch (e) {
        // analytics is best-effort — never let it break a user action
    }
}

export default track;
